import { createApp } from 'vue'
import { LinkItem } from '~/js/models/linkItem'

const ID_PAGES_CONTENTS_ALL = 'js-pages-contents-all'

const CONTENT_CATEGORIES = [
  { label: 'コーディネート', key: 'coordinate', path: '/blogs/coordinate' },
  { label: '特集', key: 'feature', path: '/blogs/feature' },
  { label: 'コラム', key: 'article', path: '/blogs/article' },
  {
    label: '新作紹介',
    key: 'product-introduction',
    path: '/blogs/introduction-movie',
  },
]

document.addEventListener('DOMContentLoaded', async () => {
  const elementPagesContentsAll = document.getElementById(ID_PAGES_CONTENTS_ALL)
  if (!elementPagesContentsAll) return

  const coordinateLinkItems = JSON.parse(
    elementPagesContentsAll.dataset.coordinateLinkItems
  ).map((linkItem) => {
    const url = `/blogs/coordinate/${linkItem.handle}`
    return new LinkItem(linkItem, url)
  })

  const featureLinkItems = JSON.parse(
    elementPagesContentsAll.dataset.featureLinkItems
  ).map((linkItem) => {
    const url = `/blogs/feature/${linkItem.handle}`
    return new LinkItem(linkItem, url)
  })

  const articleLinkItems = JSON.parse(
    elementPagesContentsAll.dataset.articleLinkItems
  ).map((linkItem) => {
    const url = `/blogs/article/${linkItem.handle}`
    return new LinkItem(linkItem, url)
  })

  const categoryLinkItems = [
    coordinateLinkItems,
    featureLinkItems,
    articleLinkItems,
  ]

  const linkItemsLength = Math.max(
    ...categoryLinkItems.map((items) => items.length)
  )

  const shuffledCategoryIndexes = Array(categoryLinkItems.length)
    .fill()
    .map((_, i) => i)
    .sort(() => Math.random() - 0.5)

  const orderedPosts = []

  for (
    let linkItemIndex = 0;
    linkItemIndex < linkItemsLength;
    linkItemIndex++
  ) {
    shuffledCategoryIndexes.forEach((categoryIndex) => {
      const item = categoryLinkItems?.[categoryIndex]?.[linkItemIndex]

      if (item) {
        let category = ''
        let badgeText = ''
        if (item.url?.includes('/blogs/coordinate/')) {
          category = 'coordinate'
          badgeText = 'Coordinate'
        } else if (item.url?.includes('/blogs/feature/')) {
          category = 'feature'
          badgeText = '特集'
        } else if (item.url?.includes('/blogs/article/')) {
          category = 'article'
          badgeText = '暮らしのヒント'
        }

        orderedPosts.push({
          item,
          category,
          badgeText,
        })
      }
    })
  }

  createApp({
    name: 'PageContentsAll',
    data() {
      return {
        orderedPosts,
      }
    },
    computed: {
      contentCategories() {
        return CONTENT_CATEGORIES
      },
    },
  }).mount(elementPagesContentsAll)
})
